import * as React from 'react'
import FontAwesomeIcon from '@components/Icon/FontAwesomeIcon'
import { faFilePdf, faUpload } from '@fortawesome/free-solid-svg-icons'

const UploaderMimeTypeIcon = ({
  mimeType,
  filename,
  placeholder,
}: {
  mimeType: string
  filename: string
  placeholder?: any
}) => {
  if (!mimeType) {
    return placeholder || <FontAwesomeIcon icon={faUpload} size={'3x'} colour={'Muted'} />
  }

  const resolveIcon = () => {
    switch (mimeType) {
      case 'application/pdf':
        return faFilePdf
    }

    return false
  }

  const resolveColor = (): Icon.Colour => {
    if (mimeType === 'application/pdf') {
      return 'Light'
    }

    return 'Dark'
  }

  const resolveMimeSpecificClass = (): string => {
    if (mimeType === 'application/pdf') {
      return 'uploader-file__preview-icon--pdf'
    }

    return ''
  }

  const icon = resolveIcon()

  if (icon) {
    return (
      <div className={`uploader-file__preview-icon ${resolveMimeSpecificClass()}`}>
        <FontAwesomeIcon icon={icon} size={'3x'} colour={resolveColor()} />
      </div>
    )
  }

  const extension = `.${filename.split('.').pop()}`

  return <span className="uploader-file__preview-extension">{extension}</span>
}
export default UploaderMimeTypeIcon
